import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["badgeImageId", "parentPlaylistIds", "hasSuccessAlert"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { playlistQueryKeys } from 'actions/playlists';
import badgeKeys from './queryKeys';
function useUpdateBadgeImage(_ref) {
  var badgeImageId = _ref.badgeImageId,
    _ref$parentPlaylistId = _ref.parentPlaylistIds,
    parentPlaylistIds = _ref$parentPlaylistId === void 0 ? [] : _ref$parentPlaylistId,
    _ref$hasSuccessAlert = _ref.hasSuccessAlert,
    hasSuccessAlert = _ref$hasSuccessAlert === void 0 ? false : _ref$hasSuccessAlert,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function updateBadgeImage(_x) {
    return _updateBadgeImage.apply(this, arguments);
  }
  function _updateBadgeImage() {
    _updateBadgeImage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(badgeImageData) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('patch', "/api/badges/images/".concat(badgeImageId), null, badgeImageData));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateBadgeImage.apply(this, arguments);
  }
  var _useMutation = useMutation(updateBadgeImage, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess() {
        if (hasSuccessAlert) {
          setSuccessAlert({
            title: t('alert_badge_image_updated_successfully')
          });
        }
        queryClient.invalidateQueries(badgeKeys.allBadgeImages);
        if ((parentPlaylistIds === null || parentPlaylistIds === void 0 ? void 0 : parentPlaylistIds.length) > 0) {
          queryClient.invalidateQueries(playlistQueryKeys.allPlaylists);
        }
      },
      onError: function onError() {
        setAlert({
          title: t('alert_badge_image_not_updated')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updateBadgeImage: mutateAsync
  });
}
export default useUpdateBadgeImage;